import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';
import sigamixLogo from '../assets/sigamixlogo.png';

const Login: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await login({ username, password });
      // La redirection se fait automatiquement via le contexte d'authentification
    } catch (err: any) {
      setError(err.response?.data?.message || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-background">
        <div className="background-pattern"></div>
      </div>
      
      <div className="login-content">
        <div className="login-card">
          <div className="login-header">
            <div className="logo-container">
              <img 
                src={sigamixLogo} 
                alt="Sigamix Logo" 
                className="logo"
                onError={(e) => {
                  console.error('Erreur de chargement du logo:', e);
                  console.log('Tentative de chargement depuis:', e.currentTarget.src);
                }}
                onLoad={(e) => {
                  console.log('Logo chargé avec succès depuis:', e.currentTarget.src);
                }}
              />
            </div>
            <h1 className="app-title">Reporting Server</h1>
          </div>
          
          <form onSubmit={handleSubmit} className="login-form">
            {error && (
              <div className="error-message">
                {error}
              </div>
            )}
            
            <div className="form-group">
              <label htmlFor="username">Nom d'utilisateur</label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                placeholder="Entrez votre nom d'utilisateur"
                className="form-input"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="password">Mot de passe</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Entrez votre mot de passe"
                className="form-input"
              />
            </div>
            
            <button 
              type="submit" 
              className="login-button"
              disabled={loading}
            >
              {loading ? 'Connexion...' : 'Se connecter'}
            </button>
          </form>
          
          <div className="login-footer">
            <p className="copyright">
              © 2025 SIGAMIX by AFINOV
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;


